"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductIconContainer = void 0;
exports.default = ProductIcon;
var _react = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _image = require("@site/pattern-library-core/image");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
/* VENDOR */

/* LOCAL */

const ProductIconContainer = exports.ProductIconContainer = /*#__PURE__*/(0, _react.styled)(_image.LazyBackgroundImage)({
  name: "ProductIconContainer",
  class: "pl-p15i6bzm",
  vars: {
    "p15i6bzm-0": [({
      height
    }) => height],
    "p15i6bzm-1": [({
      width
    }) => width],
    "p15i6bzm-2": [({
      borderRadius
    }) => borderRadius]
  }
});

/**
 * Render product icon.
 * @module ProductIcon
 *
 * @param {Object} props React props
 * @param {object} props.icon Icon name
 * @param {string} props.ariaLabel Aria Label
 * @returns {React.ReactElement} card element
 * @public
 */
function ProductIcon({
  ariaLabel,
  width = 'var(--fixed-space-400)',
  height = 'var(--fixed-space-400)',
  borderRadius = `${_patternLibraryUtils.density['3']}`,
  icon
}) {
  return /*#__PURE__*/_react2.default.createElement(ProductIconContainer, {
    role: "img",
    width: width,
    height: height,
    borderRadius: borderRadius,
    "aria-label": ariaLabel,
    "data-cy": "icon",
    isPromo: false,
    landscape: icon?.url,
    portrait: icon?.url
  });
}
ProductIcon.propTypes = {
  icon: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  borderRadius: _propTypes.default.string,
  ariaLabel: _propTypes.default.string
};